/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {
            display: 'flex',
            alignItems: 'flex-start',
            minHeight: '24px'
        },
        label: {
            width: 'full'
        },
        control: {
            backgroundColor: 'webTheme.backgroundDefault',
            width: '16px',
            height: '16px',
            borderWidth: '1px',
            borderColor: 'webTheme.iconPrimary',
            _hover: {
                background: 'webTheme.backgroundDefault',
                backgroundColor: 'webTheme.backgroundDefault',
                borderColor: 'webTheme.iconPrimary',
            },
            '& + .chakra-radio__label': {
                textStyle: 'bodySmRegular',
                minHeight: 'auto'
            },
            _checked: {
                backgroundColor: 'webTheme.backgroundDefault',
                borderColor: 'webTheme.iconPrimary',
                _hover: {
                    background: 'webTheme.backgroundDefault',
                    backgroundColor: 'webTheme.backgroundDefault',
                    borderColor: 'webTheme.iconPrimary',
                },
                _before: {
                    background: 'webTheme.iconPrimary',
                    width: '8px',
                    height: '8px',
                }
            },
            _disabled: {
                backgroundColor: 'webTheme.backgroundDefault',
                borderColor: 'webTheme.iconDisabled',
                '& + .chakra-radio__label': {
                    textStyle: 'bodySmRegular',
                    minHeight: 'auto',
                    color: 'webTypo.textDisabled'
                },
                _checked: {
                    backgroundColor: 'webTheme.backgroundDefault',
                    borderColor: 'webTheme.iconDisabled',
                    _before: {
                        background: 'webTheme.iconDisabled',
                        width: '8px',
                        height: '8px',
                    }
                }
            },
            _indeterminate: {}
        }
    },
    sizes: {
        md: {
            container: {alignItems: 'flex-start'},
            label: {
                marginLeft: 3,
                _disabled: {
                    color: 'webTypo.textDisabled'
                }
            }
        },
        shippingOption: {
            container: {alignItems: 'flex-start'},
            control: {
                margin: 1
            }
        },
        shippingExpress: {
            container: {alignItems: 'flex-start'},
            control: {
                margin: 1
            },
            label: {
                marginLeft: 0,
                _disabled: {
                    color: 'webTypo.textDisabled'
                }
            }
        },
        pickupInStore: {
            container: {
                padding: {base: 4, lg: 0},
                margin: {lg: '24px 24px 0'},
                pb: {lg: 4},
                borderBottom: '1px solid',
                borderColor: 'webTheme.strokeDefault'
            }
        }
    }
}
